import { render, staticRenderFns } from "./VAppClientSelectorItem.vue?vue&type=template&id=6d354b13&scoped=true"
import script from "./VAppClientSelectorItem.vue?vue&type=script&lang=js"
export * from "./VAppClientSelectorItem.vue?vue&type=script&lang=js"
import style0 from "./VAppClientSelectorItem.vue?vue&type=style&index=0&id=6d354b13&prod&scoped=true&lang=css"
import style1 from "./VAppClientSelectorItem.vue?vue&type=style&index=1&id=6d354b13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d354b13",
  null
  
)

export default component.exports